<template>
    <div class="head-meta-change">
        <p>mounted()でtitleとdescriptionを変更するサンプルコードです</p>
    </div>
</template>

<script>
export default {
    mounted(){
        const title = "head要素のtitleとdescritptionの変更｜あめねこサンプルコード集"
        const description = "Vue.jsで書かれたhead要素のtitleとdescritptionの変更を実装するサンプルコードです。"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    },
}
</script>

<style scoped>

</style>